module.exports = __webpack_public_path__ + "static/img/10.55e6f91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/10.jpg
// module id = Z+kq
// module chunks = 1